export enum NotifyActivityPropertyKeys {
    Id = "Id",
    Name = "Name",
    NameLanguage = "NameLanguage",
    ClrTypeID = "ClrTypeID",
    /**
     * 参与者
     */
    ParticipantSchemes = 'ParticipantSchemes',
    /**
     * PC表单
     */
    wf_ExecuteForms_PC = 'wf_ExecuteForms_PC',
    /**
     * 移动表单
     */
    wf_ExecuteForms_Mobile = 'wf_ExecuteForms_Mobile',
    /**
     * 消息通知
     */
    messageNotice = 'messageNotice',
    NotifyAble = 'NotifyAble',
}